<template>
  <div
    :data-test="dataTest"
    class="mlui-core-loading-wrapper justify-content-center">
    <span
      :class="[template, revertColor ? 'revert-color' : '']"
      class="mlui-core-loading-spinner-icon fa fa-spinner fa-spin fa-3x"
      :data-test="dataTest" />
    <span
      class="mlui-core-loading-label sr-only">{{ $t('common.messages.synchronizing') }}</span>
  </div>
</template>

<script>
export default {
  name: 'CoreLoading',
  props: {
    template: {
      type: String,
      default: 'main',
    },
    dataTest: {
      type: String,
      default: 'core-loading',
    },
    revertColor: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
  .mlui-core-loading-spinner-icon, .mlui-core-loading-label {
    color: $blue-base;
  }
  .mlui-core-loading-spinner-icon.revert-color {
    color: $blue-light;
  }
  .mlui-core-loading-wrapper {
    display: flex;
  }
</style>
